import React from 'react';

export function OrderItemsEmptyState() {
  return (
    <div className="container mt-60">
      <h2 className="text-smurfs-gold font-bold leading-none">LOOKS LIKE THERE'S NOTHING HERE...</h2>
      <div className="mt-20 font-semibold text-30">
        <p>
          We couldn't find any history of previous orders. Get started with your
          first one today.
        </p>
      </div>
    </div>
  );
}
